import React from "react"
import PropTypes from "prop-types"
import Layout from "../components/layout"
import { Link } from "gatsby-theme-material-ui"
import Seo from "../components/seo"
import kebabCase from "lodash/kebabCase"

// Components
import { graphql } from "gatsby"
import { Typography } from "@material-ui/core"

const Tags = ({ pageContext, data }) => {
  const { tag } = pageContext
  const { edges, totalCount } = data.allMdx
  const tagHeader = `${totalCount} Beitr${
    totalCount === 1 ? "ag" : "äge"
  } mit Stichwort "${tag}"`

  return (
    <Layout>
      <h1>{tagHeader}</h1>
      <Seo title={`Stichwort: ${tag}`} slug={`/tags/${kebabCase(tag)}/`} />
      <ul>
        {edges.map(({ node }) => {
          const { slug, title, excerpt, language } = node.frontmatter
          const langSlug =
            (language === null ? "de" : language) === "de" ? "" : "/" + language
          return (
            <li key={slug}>
              <Typography>
                <Link to={langSlug + slug}>{title}</Link>
              </Typography>
              <Typography>{excerpt}</Typography>
            </li>
          )
        })}
      </ul>
      <Link variant="outlined" to="/tags/">
        Alle Stichworte
      </Link>
    </Layout>
  )
}

Tags.propTypes = {
  pageContext: PropTypes.shape({
    tag: PropTypes.string.isRequired,
  }),
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              title: PropTypes.string.isRequired,
            }),
            fields: PropTypes.shape({
              slug: PropTypes.string.isRequired,
            }),
          }),
        }).isRequired
      ),
    }),
  }),
}

export default Tags

export const pageQuery = graphql`
  query ($tag: String) {
    allMdx(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: { tags: { in: [$tag] }, publishstate: { eq: "published" } }
      }
    ) {
      totalCount
      edges {
        node {
          frontmatter {
            title
            excerpt
            slug
            language
          }
        }
      }
    }
  }
`
